import { Injectable } from '@angular/core';
import { Avis } from 'src/app/models/avis';
import { TypeAvisEnum } from 'src/app/models/enums/type-avis.enum';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { StatutAvisEnum } from '../../../../../models/enums/statut-avis.enum';
import { Annonce } from '../../../common/models/annonce';
import { FormDiversAttributionService } from './formDiversAttribution/form-divers-attribution.service';
import { DiversService } from '../../common/services/divers/divers.service';
import { CommonService } from '../../../common/services/common/common.service';
import { DIVERS } from '../../common/models/Typedivers';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { TypeMontant } from '../models/TypeMontant';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { RadioCheckBoxEnum } from '../../../common/radio.checkbox.enums';

@Injectable({
	providedIn: 'root'
})
export class FormDiversAttributionExtractorService {

	constructor(private formDiversAttributionService: FormDiversAttributionService,
				private diversService: DiversService,
    			private commonService: CommonService,
				private avisDataTransferService: AvisDataTransferService,
				private stepperBuilderService: StepperBuilderService) {
	}


	public mapFormToAvis(form, stepId,actualFormIdAnnEmetteur): Avis {
		const controls = this.formDiversAttributionService.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
		const typeAnnDiversG2 = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers.attribution;

		typeAnnDiversG2.attribution = this.formDiversAttributionService.attributionService.getAttribution(controls, this.formDiversAttributionService.formExtractorService, stepId);

		if (stepId === 1) {
			typeAnnDiversG2.avisInitial = this.formDiversAttributionService.avisInitialService.getAvisInitial(controls);
		}

		if (stepId === 2) {
			typeAnnDiversG2.resultatAttribution = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_SepSep_TypeResultatAttribution_SepAtt_infructueux');
			typeAnnDiversG2.descriptionReduite = this.formDiversAttributionService.descriptionReduiteService.getDescriptionReduite(controls);
			typeAnnDiversG2.procedure = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepAtt_procedure') === null ? '' : controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepAtt_procedure');
			const dateAttribution = '_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_dateAttribution';
			const dateValue = controls.get(dateAttribution);
			const timestampValue = controls.get(dateAttribution + '_timestamp');
			// Ajouter le séparateur 'T' entre la date et l'heure pour respecter le format ISO 8601
			if (dateValue && timestampValue) {
				typeAnnDiversG2.autresInformations.dateAttribution = dateValue + 'T' + timestampValue;
			} else if (dateValue) {
				typeAnnDiversG2.autresInformations.dateAttribution = dateValue;
			} else {
				typeAnnDiversG2.autresInformations.dateAttribution = '';
			}
			typeAnnDiversG2.autresInformations.nbParticipants = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_nbParticipants');
			typeAnnDiversG2.autresInformations.nbParticipantsEtrangers = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_nbParticipantsEtrangers');
			typeAnnDiversG2.autresInformations.primeAttribuee = new TypeMontant();
			typeAnnDiversG2.autresInformations.primeAttribuee.devise = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_TypeMontant_SepAtt_devise');
			typeAnnDiversG2.autresInformations.primeAttribuee.valeur = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_TypeMontant_SepAtt_valeur');
			typeAnnDiversG2.autresInformations.valeurTotaleEstimee = new TypeMontant();
			typeAnnDiversG2.autresInformations.valeurTotaleEstimee.devise = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_valeurTotaleEstimee_SepSep_TypeMontant_SepAtt_devise');
			typeAnnDiversG2.autresInformations.valeurTotaleEstimee.valeur = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepSep_valeurTotaleEstimee_SepSep_TypeMontant_SepAtt_valeur');
			if (typeAnnDiversG2.resultatAttribution === RadioCheckBoxEnum.attribueUnique) {
				this.stepperBuilderService.addStepFieldsOnErrors('_STEP_ID_4', '_STEP_ID_4_SepSep_LotMarche_SepSep_TypeResultatAttribution_SepSep_TypeAttributionMarcheLot_SepSep_TypeAdresseCompleteMorale_SepAtt_personneMorale', 'Le dénomination du titulaire est obligatoire si le marché est attribué.');
				this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_5');
			  } else if (typeAnnDiversG2.resultatAttribution === RadioCheckBoxEnum.attribueLots
						|| typeAnnDiversG2.resultatAttribution === RadioCheckBoxEnum.lotsInfructueux) {
				this.stepperBuilderService.addStepFieldsOnErrors('_STEP_ID_5', '_STEP_ID_5_SepSep_Attribution_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_Attribution_index_1_SepSep_LotMarche_SepAtt_numLot', 'L\'identifiant du lot est obligatoire.');
				this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_4');
			  } else {
				this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_4');
				this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_5');
			  }
		}

		if(stepId === 6) {
			typeAnnDiversG2.autresInformations.informations = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_informations');
			typeAnnDiversG2.autresInformations.nbOffresRecues = controls.get('_SepSep_Attribution_SepSep_TypeAnn_DIVER_G2_SepSep_TypeAutresInfosATTR_SepAtt_nbOffresRecues');
		}

		typeAnnDiversG2.pasAvisInitial = null;
		typeAnnDiversG2.criteresAttribution = null;

		const divers: DIVERS = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.divers;
		if (stepId === 3) {
			divers.organisme = this.diversService.typeAdresseCompleteObligatoireService.getTypeAdresseCompleteObligatoire(controls);
		}
		divers.initial = null;
		divers.attribution = typeAnnDiversG2;
		divers.rectificatif = null;
    	divers.annulation = null;

		const annonce: Annonce = new Annonce();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
		annonce.ann.divers = divers;
		annonce.ann.mapa = null;
		annonce.ann.fnSimple = null;
		annonce.ann.formAD = null;
		annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
		annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
		annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

    	annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		let avis: Avis = new Avis();

		avis.jsonSaisieFormulaire = annonce;
		avis.formulaire.code = FormsEnum[FormsEnum.DIVE_AT];
		avis.statut = StatutAvisEnum.ELABORE;
		avis.critere.typeAvis.code=TypeAvisEnum.C4_3;
		return avis;
	}
}

